import localStorageHelper from './local-storage'
import { parseJSON } from './lodash'

const storageKey = 'passkeyLoginPreference'

/**
 * Returns whether this host last saw an account with a registered passkey.
 * @returns {boolean | null}
 */
export function getPasskeyLoginPreference(): boolean | null {
  const preference = parseJSON(localStorageHelper.getItem(storageKey))

  if (typeof preference === 'object' && preference !== null && 'enabled' in preference) {
    return typeof preference.enabled === 'boolean' ? preference.enabled : null
  }

  return null
}

/**
 * Remembers the account's passkey state on this host, including across logout.
 * @param {boolean | null | undefined} enabled Last known account state, or unknown.
 */
export function setPasskeyLoginPreference(enabled: boolean | null | undefined): void {
  if (typeof enabled === 'boolean') {
    localStorageHelper.setItem(storageKey, { enabled })
  } else {
    localStorageHelper.removeItem(storageKey)
  }
}
